import styled, { css } from 'styled-components';

const StyledContainer = styled.div `
  display: grid;
  padding: 10px 0;
  width: 100%;
`;
const StyledProgressBarContainer = styled.div `
  grid-area: 1 / 1;
  display: inline-block;
  width: 100%;
  position: relative;
  background: ${props => props.theme.colors.mist}33;
  height: 3px;
`;
const StyledLoadTimeProgress = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: ${props => props.secondaryValue * props.max}%;
  background: ${props => props.theme.colors.mist}80;
`;
const pseudoCss = css `
  position: absolute;
  border: none;
  transition: all ${props => props.theme.animation.duration.quick2}
    ${props => props.theme.animation.easing.productive.standard};
  visibility: ${props => (props.showCaret ? 'visible' : 'hidden')};
`;
const StyledTooltip = styled.div `
    padding: 2px 4px 0;
    font-weight: ${props => props.theme.typography.fontWeight.medium};
    font-size: ${props => props.theme.typography.text.micro.fontSize};
    line-height: ${props => props.theme.typography.text.micro.lineHeight};
    left: calc(${props => props.tooltipPosition}px - 1.2rem);
    top: -1.7rem;
    width: max-content;
    text-align: center;
    color: ${props => props.theme.colors.white};
    background-color: ${props => props.theme.colors.midnightBlueShade}66;
    border-radius: 5px;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    ${pseudoCss}
  }
`;
const StyledCurrentTimeProgress = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: ${props => props.width}px;
  background: ${props => props.theme.colors.skyBlue};

  &::before {
    content: '';
    right: -5px;
    top: -4px;
    height: 11px;
    width: 11px;
    background-color: ${props => props.theme.colors.skyBlue};
    border-radius: 50%;
    box-shadow: 0 -1px 10px 0 ${props => props.theme.colors.black}26;
    ${pseudoCss}
  }
`;

export { StyledContainer, StyledCurrentTimeProgress, StyledLoadTimeProgress, StyledProgressBarContainer, StyledTooltip };
//# sourceMappingURL=ProgressBar.styles.mjs.map
